module.exports = __webpack_public_path__ + "static/img/success11.4f309439.png";